import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import {
  Button,
  Drawer,
  Popconfirm,
  Space,
  Tabs,
  Tooltip,
  Typography,
} from 'antd';
import { AccessControl } from 'components/AccessControl';
import { DELETE_CONFIRM } from 'constants/alerts';
import { useEffect, useState } from 'react';
import { RowBlock } from 'ui/RowBlock';
import { SectionTitle } from 'ui/SectionTitle';
import { checkField, formatDate } from 'utils';
import {
  dateType,
  dayType,
  taxStatusesMap,
} from 'utils/handbooks/pushManagerHandbooks';
import { SegmentClientsTable } from './SegmentClientsTable';

// TODO after addition new fields need to refactor and fetch segment deatails
function SegmentDetail({ activeRecord, isActive, onClose, onEdit, onDelete }) {
  const [activeTab, setActiveTab] = useState('general');

  useEffect(() => {
    return () => setActiveTab('general');
  }, [activeRecord]);

  return (
    <Drawer
      width="50%"
      title={activeRecord?.title}
      visible={isActive}
      onClose={onClose}
      extra={
        <Space>
          <AccessControl pageId="segments" action="update">
            <Tooltip placement="bottomLeft" title="Редактировать">
              <Button type="default" onClick={onEdit} icon={<EditOutlined />} />
            </Tooltip>
          </AccessControl>

          <AccessControl pageId="segments" action="delete">
            <Popconfirm
              title={DELETE_CONFIRM}
              placement="bottomLeft"
              onConfirm={onDelete}
              okText="Да"
              cancelText="Нет"
            >
              <Button type="default" danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </AccessControl>
        </Space>
      }
    >
      <Tabs
        centered
        activeKey={activeTab}
        onChange={(tab) => setActiveTab(tab)}
      >
        <Tabs.TabPane tab="О сегменте" key="general">
          <SectionTitle offset={12}>Пользователь</SectionTitle>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Название сегмента:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.title)}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Дата создание:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(formatDate(activeRecord?.created_date))}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Устройство:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.device_type?.join(', '))}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Дата регистрации:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(
                activeRecord?.period &&
                  activeRecord?.period?.start_date &&
                  activeRecord?.period?.end_date
                  ? `${formatDate(
                      activeRecord?.period.start_date
                    )} - ${formatDate(activeRecord?.period.end_date)}`
                  : ''
              )}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Пользователь:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.users_is_active?.join(', '))}
            </Typography.Text>
          </RowBlock>

          <SectionTitle offset={12}>Налоги</SectionTitle>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Cтатус:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(
                activeRecord?.taxes?.taxes_status
                  .map((item) => taxStatusesMap[item])
                  .join(', ')
              )}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Дата месяца:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(dateType[activeRecord?.taxes?.taxes_type_date])}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              До/после:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.taxes?.taxes_input)}
            </Typography.Text>
          </RowBlock>

          <SectionTitle offset={12}>Услуги</SectionTitle>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Тип:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(dayType[activeRecord?.services?.service_day_type])}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Дата месяца:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(dateType[activeRecord?.services?.service_date_type])}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              До/после:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.services?.service_input)}
            </Typography.Text>
          </RowBlock>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Пользователи" key="by_clients">
          <SegmentClientsTable
            isActive={activeTab === 'by_clients'}
            segmentId={activeRecord?.id}
          />
        </Tabs.TabPane>
      </Tabs>
    </Drawer>
  );
}

export { SegmentDetail };
